module.exports = __webpack_public_path__ + "img/prod_jzx.6ea983cf.png";